import api from 'api';
const url = 'api/profile';

export default {
    save: data => api.patch({path: url,  params: {...data}})
}